module.exports = __webpack_public_path__ + "img/gongan.348499c.png";